import { Injectable } from '@angular/core';
import { from, locale } from 'jalali-moment';

@Injectable({
 providedIn: 'root',
})
export class MomentService {
 constructor() {}

 toGergorian(jalaliDate: string) {
  const newDate = new Date().toTimeString();
  const gregorianDate = from(`${jalaliDate} ${newDate}`, 'fa', 'YYYY/MM/DD HH:mm:ss').toISOString();
  return new Date(gregorianDate);
 }

 convertISOtoJalali(gregorianIsoDate: string): string {
  return from(gregorianIsoDate, 'en', 'YYYY-MM-DD').format('YYYY/MM/DD');
 }
}
